import * as ActionTypes from './actionType.js';

export const INITIALIZE_STATE = {
    isErrorDutyFecthing: false,
    check_user:{},
    entry_user:{},
    questionInfo:{},
    question_log:[],
    taskInfo:{},
    error: ''
};

const reducerMap = {

    [ActionTypes.errorDutyRequest]: (state) => {
        return Object.assign({}, state, {
            isErrorDutyFecthing: true,
            error:''
        });
    },
    [ActionTypes.errorDutySuccess]: (state, payload) => {
        return Object.assign({}, state, {
            error:'',
            isErrorDutyFecthing: false,
            ...payload.data
        });
    },
    [ActionTypes.errorDutyFailure]: (state, payload) => {
        return Object.assign({}, state, {
            isErrorDutyFecthing: false,
            error: payload.error
        });
    },

};

export default (state = INITIALIZE_STATE, action = {}) => {
    const {
        type,
        payload
    } = action;
    const reducer = reducerMap[type];

    if (reducer) {
        return reducer(state, payload);
    } else {
        return state;
    }
};


// WEBPACK FOOTER //
// ./src/entry_app/question_box/error_duty/reducer.js